import styled from 'styled-components';
import { colors, fonts, metrics } from '@/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1em;
  @media (max-width: ${metrics.mobile}px) {
    margin-bottom: 10px;
  }
`;

export const ExternalLink = styled.a`
  ${fonts.getRegularText()}
  color: ${colors.black};
  text-decoration: none;
  display: block;
  margin: 0;
  transition: color .5s;
  &:hover {
    color: ${colors.blue};
  }
`;

export const P = styled.p`
  ${fonts.getRegularText()}
  margin: 0;
`;
